import Constants from 'expo-constants';

const envApiUrl =
  process.env.EXPO_PUBLIC_API_URL ||
  process.env.API_URL;

const webDevApiUrl =
  typeof window !== 'undefined' && __DEV__
    ? `${window.location.protocol}//${window.location.hostname}:5001/api`
    : undefined;

const configApiUrl =
  Constants.expoConfig?.extra?.API_URL ||
  Constants.manifest?.extra?.API_URL;

export const API_URL = envApiUrl || webDevApiUrl || configApiUrl || 'http://localhost:5001/api';